import { useMutation, useQueryClient } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { enqueueSnackbar } from "../../root/actions";
import { getSagasMsgs } from "../../root/selectors";
import { getTomPicturesRequest, makeReportRequest } from "../api/tomApi";

export const useMakeReport = (key, options) => {
    const dispatch = useDispatch();
    const sagasMsgs = useSelector(getSagasMsgs);
    const queryClient = useQueryClient();
    return useMutation("makeReport", (params) => makeReportRequest(params), {
        onError: (e) =>
            dispatch(
                enqueueSnackbar({
                    message: sagasMsgs.tomMakeReport,
                    options: {
                        variant: "error",
                    },
                })
            ),
        cacheTime: 0,
        enabled: false,
        onSuccess: async (data, variables) => {
            // if pinder mode -> update entity state in cache
            if (key === "notProcessedPictures") {
                const {
                    data: { report_type },
                } = data;
                // fetch irrelevant images to delete from the pinder mode list
                const { data: evalNotRequired } = await getTomPicturesRequest({
                    device_id: variables.deviceId,
                    skip: 0,
                    take: 50,
                    is_without_pictures: 1,
                    is_evaluation_required: 0,
                    is_assigned: true
                });
                const evaluationNotRequiredList = evalNotRequired.map((i) => i.id).filter(i => i !== variables.id)

                // update cache
                return queryClient.setQueryData(["notProcessedPictures"], (old) => {
                    return {
                        ...old,
                        pages: old.pages.map((p) => ({
                            ...p,
                            // delete images with 'is_evaluation_required' - false
                            data: p.data
                                .filter((i) => !evaluationNotRequiredList.includes(i.id))
                                .map((i) => {
                                    if (i.id === variables.id) {
                                        return {
                                            ...i,
                                            status: "user_processed",
                                            report_type: report_type || null,
                                        };
                                    }
                                    return i;
                                }),
                        })),
                    };
                });
            }
            // reset cache and refetch
            await queryClient.invalidateQueries(key, { refetchInactive: true });
        },
        ...options,
    });
};
